import type { BlokProps } from "@trydig/storyblok";
import {
	Carousel,
	type EmblaOptionsWithScroll,
} from "@/components/ui/Carousel";
import { Container } from "@/components/ui/Container";
import type { BlokRouter } from "@/data/routes/bloks.route";
import {
	ProductCard,
	ProductCardSkeleton,
} from "@/features/products/ProductCard";
import type { BlokProductGrid } from "@/storyblok";
import { sizes } from "../Asset";
import styles from "./ProductGridBlok.module.css";

const options: EmblaOptionsWithScroll = {
	type: "chevron",
	slidesToScroll: 1,
	dragFree: true,
};

export const ProductGridBlok = ({
	blok,
	data,
}: BlokProps<BlokProductGrid, BlokRouter["products"]>) => {
	return (
		<Container>
			<div className={styles.root}>
				<span className={styles.title}>{blok.title}</span>
				<div className={styles.desktopOnlyGrid}>
					{data?.map((product) => {
						return (
							<ProductCard
								sizes={sizes(75, 33)}
								key={product.displayItemId}
								product={product}
							/>
						);
					})}
				</div>

				<Carousel options={options} className={styles.mobileOnlyCarousel}>
					{data?.map((product) => {
						return (
							<ProductCard
								sizes={sizes(75, 33)}
								key={product.displayItemId}
								product={product}
							/>
						);
					})}
				</Carousel>
			</div>
		</Container>
	);
};

export const ProductGridBlokSkeleton = ({
	blok,
}: BlokProps<BlokProductGrid, BlokRouter["products"]>) => {
	const items = Array.from({ length: 6 })
		.fill(null)
		.map((_, i) => <ProductCardSkeleton hideColors key={i} />);

	return (
		<Container>
			<div className={styles.root}>
				<span className={styles.title}>{blok.title}</span>
				<div className={styles.desktopOnlyGrid}>{items}</div>
				<Carousel className={styles.mobileOnlyCarousel}>{items}</Carousel>
			</div>
		</Container>
	);
};
